module.exports = __webpack_public_path__ + "media/images/emblems/Hitzkirch_LU-b0a64164f0301b010e50530df9556ec3.png";